var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalPatient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.554688,
    y: 0.484375,
    width: 51,
    height: 51,
    rx: 14,
    fill: "#A461D8",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.9996 12.0898C18.3607 12.0898 15.4023 15.0482 15.4023 18.6871C15.4023 22.2565 18.194 25.1454 21.8329 25.2704C21.944 25.2565 22.0551 25.2565 22.1384 25.2704C22.1662 25.2704 22.1801 25.2704 22.2079 25.2704C22.2218 25.2704 22.2218 25.2704 22.2357 25.2704C25.7912 25.1454 28.5828 22.2565 28.5968 18.6871C28.5968 15.0482 25.6385 12.0898 21.9996 12.0898Z",
    fill: "#A461D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0541 28.9766C25.179 26.3932 18.8596 26.3932 14.9568 28.9766C13.1929 30.1571 12.2207 31.7544 12.2207 33.4627C12.2207 35.1711 13.1929 36.7544 14.9429 37.9211C16.8874 39.2266 19.4429 39.8794 21.9985 39.8794C24.554 39.8794 27.1096 39.2266 29.0541 37.9211C30.8041 36.7404 31.7763 35.1571 31.7763 33.4349C31.7625 31.7266 30.8041 30.1432 29.0541 28.9766Z",
    fill: "#A461D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.2624 19.5135C37.4845 22.2079 35.5679 24.569 32.915 24.8885C32.9012 24.8885 32.9012 24.8885 32.8874 24.8885H32.8457C32.7624 24.8885 32.679 24.8885 32.6095 24.9163C31.2624 24.9857 30.0262 24.5552 29.0957 23.7635C30.5262 22.4857 31.3457 20.569 31.179 18.4857C31.0817 17.3607 30.6929 16.3329 30.1095 15.4579C30.6374 15.194 31.2484 15.0274 31.8734 14.9718C34.5957 14.7357 37.0262 16.7635 37.2624 19.5135Z",
    fill: "#A461D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0409 32.3529C39.9297 33.7003 39.0685 34.8669 37.6242 35.6586C36.2352 36.4224 34.4852 36.7836 32.7492 36.7419C33.7492 35.8391 34.3325 34.7141 34.4435 33.5196C34.5825 31.7974 33.763 30.1446 32.1242 28.8253C31.1935 28.0891 30.1102 27.5058 28.9297 27.0753C31.9992 26.1863 35.8602 26.7836 38.2352 28.7003C39.513 29.7279 40.1659 31.0196 40.0409 32.3529Z",
    fill: "#A461D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPatient);
export default __webpack_public_path__ + "static/media/TotalPatient.35ee9e4276fe0fe75d3cce2eaea8eaa4.svg";
export { ForwardRef as ReactComponent };